module.exports = __webpack_public_path__ + "static/media/chiyo.e23c1b04.png";